import React, { useState, useEffect } from 'react';
import Modal from 'jd-library/Modal';
import styles from './confirm-delete.scss';
import Button from '../../common/Button/Button';
import withPortal from 'jd-library/withPortal';

const ConfirmDelete = props => {
    const [prodName, setProdName] = useState(props.productData.productName)

    useEffect(() => {
        if(prodName && prodName.length > 100){
            let truncatedName = props.productData.productName.substr(0, 100) + '...';
            setProdName(truncatedName);
        }
    }, [])
    let textlabel = 'Product';
    if((props.productData.type == 'service' && !props.isMultiSelect) || props.serviceProfile){
        textlabel = 'Service';
    }
    return (
        <div className={styles['add-edit-block-modal']}>
            <Modal
                settings={{
                    modalId: 'confirm-delete-modal',
                    variant: 'action'
                }}
                onHidden={() => props.onModalClose()}
            >
                <Modal.CloseIcon />
                <Modal.Header>
                    <span className={styles['title']}>Delete Item(s)</span>
                </Modal.Header>
                <Modal.Body className={styles['modal-body']}>
                    <div className={styles['subtitle']}>
                        Are you sure you want to delete {props.isMultiSelect && props.productsLength > 1 ? props.productsLength + ' item(s)' : (props.isGalleryProd ? 'this product' : <span className={styles['bold-text']}>{prodName}</span>)}?
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles['button-wrapper']}>
                        <Button size='lg' clickHandler={props.onDelete} className={`${styles['delete-btn']}`}>
                            {/* {props.isMultiSelect && props.productsLength > 1 ? 'Delete Products' : ('Delete '+textlabel)} */}
                           Delete
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default withPortal(ConfirmDelete, null, 'confirm-delete-modal');

